import React, { useEffect, useState, useRef } from "react";
import IconButton from "@mui/material/IconButton";
import rechargeCardBackground from '../media/icons/backgrounds/rechargecard.png';
import Grid from "@mui/material/Grid";
import '../../MainStyle.css';
import Typography from "@mui/material/Typography";
import { getStorage } from "../modals/Storage";
import general from "../css/General.module.css";
import {
  Box,
  Button,
  SvgIcon,
  TextField,
  Card,
  CardContent,
  InputAdornment,
} from "@mui/material";
import ToastDialog from "../dialogs/ToastDialog/toast";
import { useNavigate } from "react-router-dom";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import CloseIcon from "@mui/icons-material/Close";
const RhombusIcon = (props) => (
  <SvgIcon {...props}>
    <path d="M12 2L22 12L12 22L2 12L12 2Z" />
  </SvgIcon>
);

const depositAmounts = [
  100, 500, 5000, 10000, 20000, 50000,
];

const PromotionMain = ({ children }) => {
  useEffect(() => {
    const setVh = () => {
      const vh = window.innerHeight * 0.01;
      document.documentElement.style.setProperty("--vh", `${vh}px`);
    };

    window.addEventListener("resize", setVh);
    setVh();

    return () => window.removeEventListener("resize", setVh);
  }, []);

  const [remainingTime, setRemainingTime] = useState(300); 
  const timerRef = useRef(null);
  const [amount, setAmount] = useState("");
  const [walletAmount, setWalletAmount] = useState(0);
  const [imageUrl, setImageUrl] = useState("");
  const [depositHistories, setDepositHistories] = useState([]);

  const [conversionRate, setConversionRate] = useState(91);

  useEffect(() => {
    const fetchPrice = async () => {
      try {
        const response = await fetch('https://api.coingecko.com/api/v3/simple/price?ids=usd&vs_currencies=inr');
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        const data = await response.json();
        setConversionRate(data.usd.inr); 
      } catch (error) {
        console.error("Error fetching the conversion rate:", error);
      }
    };

    fetchPrice();
  }, []);

  const [walletData, setWalletData] = useState(0);
  const [openDepositDialog, setOpenDepositDialog] = useState(false);
  const [utr, setUtr] = useState("");
  const [utrAlert, setUtrAlert] = useState(false);
  const [duplicateUtrAlert, setDuplicateUtrAlert] = useState("");
  const [depositRequests, setDepositRequests] = useState([]);
  const [usdtAmount, setUsdtAmount] = useState("");
  const handleUtrChange = (event) => {
    setUtr(event.target.value);
  };
  const handleUsdtInputChange = (event) => {
    const value = event.target.value;
    setUsdtAmount(value);
    if (value !== "") {
      setAmount((parseFloat(value) * conversionRate).toFixed(2));
    } else {
      setAmount("");
    }
  };

  const closeDepositDialog = () => {
    setOpenDepositDialog(false);
  };

  const [paymentMode, setPaymentMode] = useState("UPI x QR");
  const [userData, setUserData] = React.useState(null);
  useEffect(() => {
    if (paymentMode === "USDT" && amount !== "") {
      setUsdtAmount((parseFloat(amount) / conversionRate).toFixed(2));
    }
  }, [paymentMode]);

  const handleButtonClick = (value) => {
    setAmount(value.toString());
    if (paymentMode === "USDT") {
      setUsdtAmount((value / conversionRate).toFixed(2));
    }
  };
  const handleInputChange = (event) => {
    const value = event.target.value;
    setAmount(value);
    if (paymentMode === "USDT" && value !== "") {
      setUsdtAmount((parseFloat(value) / conversionRate).toFixed(2));
    }
  };
  const sendDepositRequest = async () => {
    setUtrAlert(false);
    setDuplicateUtrAlert("");
    if (!utr) {
      setUtrAlert(true);
      return;
    }

    if (
      depositRequests.some(
        (request) => request.utr === utr && request.userId === userData.userId
      )
    ) {
      setDuplicateUtrAlert(
        "This UTR has already been used. Please enter a unique UTR."
      );
      return;
    }

  };

  useEffect(() => {
    if (openDepositDialog) {
      timerRef.current = setInterval(() => {
        setRemainingTime((time) => time - 1);
      }, 1000);
    } else {
      clearInterval(timerRef.current);
      setRemainingTime(300);
    }

    return () => clearInterval(timerRef.current);
  }, [openDepositDialog, imageUrl]);

  useEffect(() => {
    if (remainingTime === 0) {
      setOpenDepositDialog(false);
    }
  }, [remainingTime]);

  const [toastDialogConst, setToastDialogConst] = useState({
    toastDialogShow: false,
    toastDialogMode: 1,
    toastMessage: "",
  });

  const updateToastDialogState = (data, mode, msg) => {
    // mode: 1 / success
    // mode: 2 / warning

    setToastDialogConst((previousState) => {
      return { ...previousState, toastDialogShow: data };
    });

    setToastDialogConst((previousState) => {
      return { ...previousState, toastDialogMode: mode };
    });

    setToastDialogConst((previousState) => {
      return { ...previousState, toastMessage: msg };
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

  };

  const [upiId, setUpiId] = useState("best4world6677@okaxis");
  const [usdtWalletAddress, setUsdtWalletAddress] = useState("");
  const navigate = useNavigate();
  const handleRedirect = () => {
    navigate(-1);
  };

  const handlePage = () => {
    navigate("/rechargerecords");
  };

  const paymentModes = {
    "UPI x QR": [
      { name: "UPI-Okpay", balance: "500 - 50K" },
      { name: "UPI-Super", balance: "300 - 50K" },
      { name: "UPI-OoPay", balance: "100 - 50K" },
    ],
    UPIxPAYTM: [
      { name: "PAYTM-Fast", balance: "100 - 10K" },
      { name: "PAYTM-Safe", balance: "500 - 20K" },
      { name: "PAYTM-Safe", balance: "500 - 20K" },
    ],
    UPIxAPP: [
      { name: "APP-Fast", balance: "100 - 10K" },
      { name: "APP-Safe", balance: "500 - 20K" },
      { name: "APP-Safe", balance: "500 - 20K" },
    ],
    RupeeLink: [
      { name: "RupeeLink", balance: "100 - 1000K" },
    ],

    USDT: [
      { name: "USDT-Tether", balance: "50 - 100 USDT" },
      { name: "USDT-Binance", balance: "100 - 200 USDT" },
    ],
 
    
  };
  const defaultChannelMap = {
    "UPI x QR": 0, 
    "UPIxPAYTM": 0, 
    "USDT": 0, 
    "UPIxAPP": 0,
    "RupeeLink": 0,
  };
  const [selectedChannel, setSelectedChannel] = useState(defaultChannelMap[paymentMode] || 0);
  useEffect(() => {
    setSelectedChannel(defaultChannelMap[paymentMode] || 0);
  }, [paymentMode]);

    const DepositNow = (e) => {
      e.preventDefault();

      if (amount < getStorage("minrecharge")) {
        alert("Amount must be at least 100");
        return;
      }
      let UserId = getStorage("uid");
      let paymentUrl;
      switch (paymentMode) {
        case "UPIxPAYTM":
          paymentUrl = `https://manual.leo99.space?am=${amount}&crudentials=${getStorage("uid")}`;
          break;

        case "UPI x QR":

          const selectedPaymentMode = paymentModes[paymentMode][selectedChannel];
          switch (selectedPaymentMode.name) {
            case "UPI-Okpay":
          paymentUrl = `https://manual.leo99.space?am=${amount}&crudentials=${getStorage("uid")}`;
              break;
            case "UPI-Super":
          paymentUrl = `https://manual.leo99.space?am=${amount}&crudentials=${getStorage("uid")}`;


              break;
            case "UPI-OoPay":
          paymentUrl = `https://manual.leo99.space?am=${amount}&crudentials=${getStorage("uid")}`;

              break;
            default:
              console.log("Unknown UPI x QR channel");
          }
          break;


         


        case "USDT":

          const usdtPaymentMode = paymentModes[paymentMode][selectedChannel];
          console.log(`Depositing using ${usdtPaymentMode.name}`);
          paymentUrl = `https://manual.leo99.space?am=${amount}&crudentials=${getStorage("uid")}`;
          
          break;
          
       case "UPIxAPP":

          const upiPaymentMode = paymentModes[paymentMode][selectedChannel];
          console.log(`Depositing using ${upiPaymentMode.name}`);
          paymentUrl = `https://manual.leo99.space?am=${amount}&crudentials=${getStorage("uid")}`;
          
          break;

          case "RupeeLink":

          const upiPaymentMode2 = paymentModes[paymentMode][selectedChannel];
          paymentUrl = `https://manual.leo99.space?am=${amount}&crudentials=${getStorage("uid")}`;
          
          break;

          
        default:
          console.log("Unknown payment mode");
          return; 
      }

      var newForm = document.createElement("form");
      newForm.method = "POST";
      newForm.action = paymentUrl;
    
      var pastInput = document.createElement("input");
      pastInput.type = "hidden";
      pastInput.name = "order_amount";
      pastInput.value = amount;
    
      var authInput = document.createElement("input");
      authInput.type = "hidden";
      authInput.name = "order_userid";
      authInput.value = UserId;
    
      newForm.appendChild(pastInput);
      newForm.appendChild(authInput);
    
      document.body.appendChild(newForm);
      newForm.submit();
    
      // Show success toast after valid form submission
      updateToastDialogState(true, 1, "Order Created Successfully!");
    };
  const [get1, setGet1] = useState("");
  const [get2, setGet2] = useState("");
  return (
    <div className={[general.viewCenter, general.appBackground].join(" ")}>
    <div
      className={[
        general.height100vh,
        general.respWidth,
        general.overflowScrollY,
        general.appContentsBackground,
        general.hideScrollBar,
      ].join(" ")}
    >
        <ToastDialog
          intentData={toastDialogConst}
          updateState={updateToastDialogState}
        />
    <div>
        <Box
          display="flex"
          flexDirection="column"
          height="calc(var(--vh, 1vh) * 100)"
          position="relative"
        >
          <Box flexGrow={1}>
            <Grid
              container
              alignItems="center"
              justifyContent="space-between"
              sx={{
                position: "sticky",
                top: 0,
                zIndex: 1000,
                backgroundColor: "#2B3270",
                padding: "7px 4px",
                color: "#F0F1F5",
              }}
            >
              <Grid item container alignItems="center" justifyContent="center">
                <Grid item xs={3}>
                  <IconButton
                    sx={{ mr: 8 }}
                    onClick={handleRedirect}
                  >
                    <ArrowBackIosNewIcon sx={{ color:"white" , fontSize: "16px" }} />
                  </IconButton>
                </Grid>
                <Grid item xs={6}>
                  <Typography
                    variant="h6"
                    sx={{
                      flexGrow: 1,
                      textAlign: "center",
                      mr: 3,
                      lineHeight: 1.5,
                    }}
                  >
                    Deposit
                  </Typography>
                </Grid>
                <Grid item xs={3}>
                  <Typography
                    variant="caption"
                    sx={{
                      textAlign: "left",
                      fontSize: "13px",
                      flexGrow: 1,
                      fontfamily: "Roboto",
                    }}
                    onClick={handlePage}
                  >
                    Deposit history
                  </Typography>
                </Grid>
              </Grid>
            </Grid>

            <Grid
              container
              mt={0}
              style={{
                backgroundImage: `url(${rechargeCardBackground})`,
                borderRadius: 8,
                padding: 8,
                backgroundSize: "cover",
                width: "93%",
                marginLeft: "auto",
                marginRight: "auto",
                height: "165px",
                marginTop: "1rem",
                position: "relative",
              }}
            >
              <Grid container item alignItems="center">
                <Grid item xs={1.5} align="center">
                  <img
                    src={require("../media/icons/walletrechargeheader.png")}
                    alt="Your Image"
                    style={{ maxWidth: "50%" }}
                  />         
                </Grid>
                <Grid item xs={10.5}>
                  <Typography
                    fontSize="15px"
                    sx={{ color: "#ffffff" }}
                    align="left"
                  >
                    Balance
                  </Typography>
               
                </Grid>
              </Grid>
              <Grid container item alignItems="center" mt={-3}>
                <Grid
                  item
                  xs={12}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    marginLeft: "20px",
                  }}
                >
                  <Typography
                    fontSize="30px"
                    sx={{ color: "#ffffff", fontWeight: "bold" }}
                  >
                    ₹ {Number(getStorage("balance")).toFixed(2).toLocaleString()}
                  </Typography>
                  <img
                      src={require("../media/icons/refresh_icon.png")}
                      style={{
                        height: "20px",
                        width: "30px",
                        marginLeft : "15px"
                        
                      }}
                    />

                    
                </Grid>
              </Grid>

              <Grid
                container
                item
                alignItems="center"
                style={{ marginTop: 16 }}
              >
                <Grid item xs={3}></Grid>
                <Grid item xs={9}>
                  <Typography
                    variant="body1"
                    sx={{ color: "#9e9c9b" }}
                  ></Typography>
                </Grid>
              </Grid>
            </Grid>

            <Grid
              container
              spacing={1}
              mt={0}
              style={{
                width: "96%",
                marginLeft: "auto",
                marginRight: "10px",
                alignItems: "center",
              }}
            >
              {Object.keys(paymentModes).map((mode) => (
                <Grid item xs={4} key={mode}>
                  <div
                    style={{
                      textAlign:"center",
                      background:
                        paymentMode === mode
                          ? "linear-gradient(90deg, #2AAAF3 0%, #2979F2 100%)"
                          : "#2B3270",
                      borderRadius: 8,
                      color: paymentMode === mode ? "#ffffff" : "#ACAFC2",
                      padding: 16,
                      boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",
                    }}
                    onClick={() => {
                      setPaymentMode(mode);
                      setSelectedChannel(null); 
                    }}
                  >
                    <img
                      src={`/channels/${mode}.png`}
                      alt={mode}
                      style={{
                        display: "block",
                        margin: "0 auto",
                        height: "55px",
                        width: "64px",
                      }}
                    />
                    <Typography
                      variant="caption"
                      align="center"
                      style={{ marginTop: 8 }}
                    >
                      {mode}
                    </Typography>
                  </div>
                </Grid>
              ))}
            </Grid>
            <Box
              sx={{
                borderRadius: "12px",
                padding: "12px",
                paddingBottom: "15px",
                paddingTop: "15px",
                backgroundColor: "#2B3270",
                boxShadow: "rgb(208 208 237 / 36%) 0px 0.05333rem 0.21333rem",
                width: "95%",
                marginLeft: "10px",
                mt: 2,
              }}
            >
              <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
              <svg
      width="30"
      height="30"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M42.5 44H5.5C4.68 44 4 43.32 4 42.5C4 41.68 4.68 41 5.5 41H42.5C43.32 41 44 41.68 44 42.5C44 43.32 43.32 44 42.5 44Z"
        fill="#61a9ff"
      />
      <path
        opacity="0.4"
        d="M41.1778 27.3975L26.7178 41.8575C26.0471 42.5318 25.25 43.0672 24.3722 43.4331C23.4944 43.7991 22.553 43.9884 21.602 43.9903C20.6509 43.9921 19.7088 43.8065 18.8296 43.4439C17.9503 43.0814 17.1512 42.5491 16.4778 41.8775L7.25781 32.6575L31.9778 7.9375L41.1978 17.1575C41.8694 17.8309 42.4017 18.63 42.7643 19.5093C43.1268 20.3885 43.3124 21.3306 43.3106 22.2816C43.3087 23.2327 43.1194 24.174 42.7534 25.0519C42.3875 25.9297 41.8521 26.7268 41.1778 27.3975Z"
        fill="#61a9ff"
      />
      <path
        d="M31.9775 7.94059L7.23746 32.6606L5.41746 30.8406C4.74583 30.1672 4.21354 29.3681 3.85101 28.4888C3.48849 27.6096 3.30284 26.6675 3.3047 25.7164C3.30656 24.7654 3.49588 23.824 3.86184 22.9462C4.22779 22.0684 4.76321 21.2713 5.43746 20.6006L19.8975 6.14058C20.5682 5.46633 21.3653 4.93092 22.2431 4.56496C23.1209 4.19901 24.0623 4.00968 25.0133 4.00783C25.9644 4.00597 26.9065 4.19161 27.7857 4.55414C28.6649 4.91666 29.4641 5.44896 30.1375 6.12058L31.9775 7.94059ZM25.7795 35.1986L23.0795 37.8986C22.5195 38.4586 21.6195 38.4586 21.0595 37.8986C20.9263 37.7662 20.8206 37.6089 20.7485 37.4355C20.6764 37.2622 20.6393 37.0763 20.6393 36.8886C20.6393 36.7008 20.6764 36.515 20.7485 36.3416C20.8206 36.1683 20.9263 36.0109 21.0595 35.8786L23.7595 33.1786C24.3195 32.6186 25.2195 32.6186 25.7795 33.1786C26.3395 33.7386 26.3395 34.6386 25.7795 35.1986ZM34.5395 26.4406L29.1595 31.8206C28.5995 32 .3806 27.6995 32.3806 27.1395 31.8206C27.0063 31.6882 26.9006 31.5309 26.8285 31.3575C26.7564 31.1842 26.7193 30.9983 26.7193 30.8106C26.7193 30.6228 26.7564 30.437 26.8285 30.2636C26.9006 30.0903 27.0063 29.9329 27.1395 29.8006L32.5195 24.4206C33.0795 23.8606 33.9795 23.8606 34.5395 24.4206C35.0795 24.9806 35.0795 25.8806 34.5395 26.4406Z"
        fill="#61a9ff"
      />
    </svg>
                <Typography
                  variant="h6"
                  color="white"
                  sx={{ fontSize: "1rem", fontWeight: "bold" }}
                >
                  Select channel
                </Typography>
              </Box>

              <div className="grid-container">
      {paymentModes[paymentMode].map((channel, index) => (
        <div
          key={index}
          className={`grid-item ${selectedChannel === index ? "selected" : ""}`}
          onClick={() => setSelectedChannel(index)}
        >
          <div className="card-items">
            <div className={`card-content ${selectedChannel === index ? "selected" : ""}`}>
              <p className="channel-name">
                {channel.name}
              </p>
              <p className="channel-balance">
                Balance: {channel.balance}
              </p>
            </div>
          </div>
        </div>
      ))}
    </div>
            </Box>

            <Box
              sx={{
                bgcolor: "#2B3270",
                p: 2,
                borderRadius: 2,
                margin: "10px",
              }}
            >
              <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
              <svg
      width="30"
      height="30"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M29.7 15.4996V7.89961C29.7 5.71961 27.9 4.09961 25.9 4.09961C25.46 4.09961 25 4.17961 24.56 4.33961L8.68004 10.3396C6.46004 11.1796 5.00004 13.2996 5.00004 15.6796V23.0196C5.00004 20.5596 6.18004 18.3796 8.00004 17.0196V15.6796C8.00004 14.5396 8.68004 13.5396 9.74004 13.1396L25.6 7.15961C25.7 7.11961 25.8 7.09961 25.9 7.09961C26.22 7.09961 26.7 7.35961 26.7 7.89961V15.4996H29.7ZM43 30.9996V28.9996C43 28.4596 42.58 28.0196 42 27.9996H38.98C38.7194 27.9951 38.4606 28.0442 38.2197 28.144C37.9789 28.2438 37.7611 28.3921 37.58 28.5796C37.18 28.9796 36.94 29.5596 37 30.1796C37.08 31.2196 38.04 31.9996 39.1 31.9996H42.02C42.2818 31.9944 42.531 31.8867 42.7142 31.6997C42.8975 31.5128 43.0001 31.2614 43 30.9996ZM5.00004 31.7596C6.38004 30.6596 8.12004 29.9996 10 29.9996C14.42 29.9996 18 33.5796 18 37.9996C18 39.4996 17.58 40.9196 16.84 42.1196C16.42 42.8396 15.88 43.4796 15.26 43.9996C13.86 45.2596 12.02 45.9996 10 45.9996C8.62116 46.0025 7.26531 45.6462 6.06596 44.9659C4.86661 44.2855 3.8651 43.3046 3.16004 42.1196C2.42004 40.9196 2.00004 39.4996 2.00004 37.9996C1.99643 36.8005 2.26448 35.6161 2.78406 34.5354C3.30363 33.4547 4.06125 32.5057 5.00004 31.7596ZM7.62669 34.2867C7.24931 33.8621 6.59918 33.8238 6.17459 34.2012C5.75 34.5786 5.71173 35.2287 6.08911 35.6533L8.22438 38.0557L6.08892 40.4581C5.71152 40.8826 5.74976 41.5328 6.17434 41.9102C6.59892 42.2876 7.24905 42.2493 7.62645 41.8248L10.3693 38.739C10.7157 38.3493 10.7157 37.7621 10.3693 37.3724L7.62669 34.2867ZM11.741 34.2867C11.3636 33.862 1 10.7135 33.8238 10.2889 34.2012C9.86428 34.5786 9.82601 35.2287 10.2034 35.6533L12.3387 38.0557L10.2032 40.4581C9.8258 40.8826 9.86405 41.5328 10.2886 41.9102C10.7132 42.2876 11.3633 42.2493 11.7407 41.8248L14.4836 38.739C14.83 38.3493 14.83 37.7621 14.4836 37.3724L11.741 34.2867Z"
        fill="#61a9ff"
      />
      <path
        d="M38.96 25.9H41C42.1 25.9 43 25 43 23.9V23.02C43 18.88 39.62 15.5 35.48 15.5H12.52C10.82 15.5 9.26 16.06 8 17.02C6.18 18.38 5 20.56 5 23.02V26.58C5 27.34 5.8 27.82 6.52 27.58C7.64 27.2 8.82 27 10 27C16.06 27 21 31.94 21 38C21 39.44 20.62 41.02 20.02 42.42C19.7 43.14 20.2 44 20.98 44H35.48C39.62 44 43 40.62 43 36.48V36.1C43 35 42.1 34.1 41 34.1H39.26C37.34 34.1 35.5 32.92 35 31.06C34.6 29.54 35.08 28.06 36.08 27.1C36.82 26.34 37.84 25.9 38.96 25.9V25.9ZM28 25.5H18C17.18 25.5 16.5 24.82 16.5 24C16.5 23.18 17.18 22.5 18 22.5H28C28.82 22.5 29.5 23.18 29.5 24C29.5 24.82 28.82 25.5 28 25.5Z"
        fill="#61a9ff"
      />
    </svg>
                <Typography color="white" variant="h7" sx={{ fontWeight: "bold" }}>
                  Deposit amount
                </Typography>
              </Box>

              <Grid container spacing={1}>
                {depositAmounts.map((value) => (
                  <Grid item xs={4} key={value}>
                    <Button
                      onClick={() => handleButtonClick(value)}
                      startIcon={
                        <Typography sx={{ color: "#757BA6", fontsize: "16px" }}>₹</Typography>
                      }
                      sx={{
                        width: "100%",
                        bgcolor: "#2B3270",
                        color: "#000000",
                        border: "0.01333rem solid #374992",
                        justifyContent: "center", 
                        "& .MuiButton-startIcon": {
                          position: "absolute", 
                          left: "16px", 
                        },
                      }}
                    >
                      <Typography color="#61a9ff" variant="h7">
                      {value >= 1000 ? `${value / 1000}K` : value}
                      </Typography>
                    </Button>
                  </Grid>
                ))}
              </Grid>
              {paymentMode === "USDT" && (
  <TextField
    style={{ background: "#22275B", color: "white" }}
    fullWidth
    placeholder="Please enter USDT amount"
    value={usdtAmount}
    onChange={handleUsdtInputChange}
    InputProps={{
      startAdornment: (
        <InputAdornment position="start" sx={{ color: "white" }}> {}
          USDT
        </InputAdornment>
      ),
      endAdornment: (
        <InputAdornment position="end">
          <IconButton
            onClick={() =>
              handleUsdtInputChange({ target: { value: "" } })
            }
          >
            <CloseIcon />
          </IconButton>
        </InputAdornment>
      ),
    }}
    sx={{
      marginTop: "1rem",
      bgcolor: "grey.200",
      borderRadius: "10px",
      "& .MuiOutlinedInput-root": {
        borderRadius: "8px",
        "& fieldset": {
          border: "none",
        },
        "&:hover fieldset": {
          border: "none",
        },
        "&.Mui-focused fieldset": {
          border: "none",
        },
        "& .MuiInputBase-input::placeholder": {
          color: "#ACAFC2", 
          opacity: 1, 
        },
        "& .MuiInputBase-input": {
          color: "white", 
        },
      },
    }}
  />
)}

              <Box sx={{ position: "relative", mt: 2, color:"red" }}>
                <TextField style={{background:"#22275B"}}
                  fullWidth
                  placeholder="Please enter the amount"
                  value={amount}
                  onChange={handleInputChange}
                  InputProps={{
                    startAdornment: (
                      <div className="depositamount-currency" position="start">₹</div>
                    ),
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          onClick={() =>
                            handleInputChange({ target: { value: "" } })
                          }
                        >
                          <CloseIcon />
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                  sx={{
                    bgcolor: "grey.200",
                    borderRadius: "10px",
                    "& .MuiOutlinedInput-root": {
                      borderRadius: "8px",
                      "& fieldset": {
                        border: "none",
                      },
                      "&:hover fieldset": {
                        border: "none",
                      },
                      "&.Mui-focused fieldset": {
                        border: "none",
                      },
                      "& .MuiInputBase-input::placeholder": {
            color: "#ACAFC2", 
            opacity: 1, 
          },
          "& .MuiInputBase-input": {
            color: "white", 
          },
                    },
                  }}
                />
              </Box>

              <Button
        fullWidth
        variant="contained"
        sx={{
          mt: 2,
          textTransform: "initial",
          bgcolor: "linear-gradient(90deg, #2AAAF3 0%, #2979F2 100%)",
          borderRadius: "16px",
          color: "white",
          "&:hover": { bgcolor: "linear-gradient(90deg, #2AAAF3 0%, #2979F2 100%)" },
          boxShadow: "none",
        }}
        onClick={DepositNow}
      >
        Deposit
      </Button>
            </Box>

            <Box
              sx={{
                margin: "10px auto", 
                borderRadius: 2,
                bgcolor: "#2B3270",

                mt: 2, 
                width: "94%",
              }}
            >
              <Box sx={{ padding: 2 }}>
                {" "}
                {}
                <Box display="flex" alignItems="center" mb={2}>
                  {" "}
                  {}
                  <svg
      width="30"
      height="30"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7 37C7 29.2967 7 11 7 11C7 7.68629 9.68629 5 13 5H35V31C35 31 18.2326 31 13 31C9.7 31 7 33.6842 7 37Z"
        fill="#61a9ff"
        stroke="#61a9ff"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M35 31C35 31 14.1537 31 13 31C9.68629 31 7 33.6863 7 37C7 40.3137 9.68629 43 13 43C15.2091 43 25.8758 43 41 43V7"
        stroke="#61a9ff"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14 37H34"
        stroke="#61a9ff"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
                  <Typography color="white" variant="body1" fontWeight="bold" align="left">
                    Recharge Instructions
                  </Typography>
                </Box>
                <Box
                  sx={{
                    border: "1px solid #E0E0E0", 
                    borderRadius: 1, 
                    padding: 2, 
                    ml: 0, 
                  }}
                >
                  <Typography
                    variant="body2"
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      mb: 1.5, 
                      color: "#ACAFC2",
                    }}
                    align="left"
                  >
                    <RhombusIcon
                      sx={{ fontSize: 12, color: "#61a9ff", mr: 1 }} 
                    />
                    If the transfer time is up, please fill out the deposit form
                    again.
                  </Typography>
                  <Typography
                    variant="body2"
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      mb: 1.5, 
                      color: "#ACAFC2",
                    }}
                    align="left"
                  >
                    <RhombusIcon
                      sx={{ fontSize: 12, color: "#61a9ff", mr: 1 }} 
                    />
                    The transfer amount must match the order you created,
                    otherwise the money cannot be credited successfully.
                  </Typography>
                  <Typography
                    variant="body2"
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      mb: 1.5, 
                      color: "#ACAFC2",
                    }}
                    align="left"
                  >
                    <RhombusIcon
                      sx={{ fontSize: 12, color: "#61a9ff", mr: 1 }} 
                    />
                    If you transfer the wrong amount, our company will not be
                    responsible for the lost amount!
                  </Typography>
                  <Typography
                    variant="body2"
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      color: "#ACAFC2",
                    }}
                    align="left"
                  >
                    <RhombusIcon
                      sx={{ fontSize: 12, color: "#61a9ff", mr: 1 }} 
                    />
                    Note: Do not cancel the deposit order after the money has
                    been transferred.
                  </Typography>
                </Box>
              </Box>
            </Box>
            {/* <Box sx={{ paddingX: "1rem" }}>
              {}
              <Typography
                variant="h6"
                sx={{
                  textAlign: "left",
                  marginBottom: "10px",
                  fontWeight: "bold",
                  color: "#FFF",
                  display: "flex",

                  ml: 1,
                }}
              >
                <svg
      width="30"
      height="30"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M41 10H13V44H41V10Z"
        fill="#61a9ff"
        stroke="#61a9ff"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M35 10V4H8C7.44772 4 7 4.44772 7 5V38H13"
        stroke="#61a9ff"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21 22H33"
        stroke="#2B3270"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21 30H33"
        stroke="#2B3270"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
                Recent Deposit History
              </Typography>

              <div>
                {depositHistories.length > 0 ? (
                  depositHistories.map((deposit) => (
                    <Card
                      key={deposit.depositId}
                      sx={{
                        marginBottom: "16px",
                        borderRadius: "8px",
                        boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                      }}
                    >
                      <CardContent
                        sx={{ padding: "16px", position: "relative" }}
                      >
                        <Grid
                          container
                          mt={-1}
                          mb={1}
                          sx={{ borderBottom: "1px solid #eee" }}
                        >
                          <Grid item xs={3}>
                            <Box
                              sx={{
                                color: "#FFFFFF",
                                fontWeight: "bold",
                                borderRadius: "5px",
                                padding: "4px 0px",
                                marginBottom: "10%",
                                fontSize: "14px",
                                textAlign: "center",
                              }}
                            >
                              Deposit
                            </Box>
                          </Grid>
                          <Grid item xs={6}>
                            <Typography
                              variant="body2"
                              sx={{
                                position: "absolute",
                                right: "16px",
                                top: "13px",
                                fontSize: "14px",
                                fontWeight: "bold",
                              }}
                            >
                              {deposit.depositStatus}
                            </Typography>
                          </Grid>
                        </Grid>
                        <Grid container spacing={1}>
                          <Grid item xs={3} textAlign="left">
                            <Typography
                              variant="body2"
                              sx={{ color: "#757575" }}
                            >
                              Balance
                            </Typography>
                          </Grid>
                          <Grid item xs={9} textAlign="end">
                            <Typography
                              variant="body2"
                              sx={{ fontWeight: "500", color: "orange" }}
                            >
                              ₹{deposit.depositAmount}
                            </Typography>
                          </Grid>
                          <Grid item xs={3} textAlign="left">
                            <Typography
                              variant="body2"
                              sx={{ color: "#757575" }}
                            >
                              Type
                            </Typography>
                          </Grid>
                          <Grid item xs={9} textAlign="end">
                            <Typography variant="body2">
                              {deposit.depositMethod}
                            </Typography>
                          </Grid>
                          <Grid item xs={3} textAlign="left">
                            <Typography
                              variant="body2"
                              sx={{ color: "#757575" }}
                            >
                              Time
                            </Typography>
                          </Grid>
                          <Grid item xs={9} textAlign="end">
                            <Typography variant="body2">
                              {new Date(deposit.depositDate).toLocaleString()}
                            </Typography>
                          </Grid>
                          <Grid item xs={4} textAlign="left">
                            <Typography
                              variant="body2"
                              sx={{ color: "#757575" }}
                            >
                              Order number
                            </Typography>
                          </Grid>
                          <Grid item xs={8} textAlign="end">
                            <Typography variant="body2">
                              {deposit.depositId}
                            </Typography>
                          </Grid>
                        </Grid>
                      </CardContent>
                    </Card>
                  ))
                ) : (
                  <Box sx={{ textAlign: "center", marginTop: "20px" }}>
                    <img
                      src={require("../media/icons/recordempty.png")} 
                      alt="No data available"
                      style={{ width: "150px", marginBottom: "10px" }}
                    />
                    <Typography
                      variant="body2"
                      sx={{
                        textAlign: "center",
                        color: "#757575",
                        marginBottom:"1rem"
                      }}
                    >
                      No deposit history available.
                    </Typography>
                  </Box>
                )}
              </div>
            </Box> */}
          </Box>

          {children}
        </Box>
      </div>
      </div>
    </div>
  );
};

export default PromotionMain;